import { Percent } from '../../../../../../domain/Percent';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageDiffTransformerEndPercentEvaluation {
  private readonly ruleName =
    'Mv_EnergyConsumer_VoltageDiffTransformerEndPercent';

  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluate(
    VoltageDiffTransformerEndPercent: number
  ): EvaluationResultType<Percent> {
    const rule = this.ruleProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      VoltageDiffTransformerEndPercent
    );
    const value = Percent.fromFloat(VoltageDiffTransformerEndPercent);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
